var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V20C32 21.1046 31.1046 22 30 22H2C0.895431 22 0 21.1046 0 20V2Z",
    fill: "#404486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 14.7586H12.2361L13.527 7.2666H15.5908L14.3 14.7586Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7822 7.44885C21.3751 7.29726 20.7294 7.12988 19.931 7.12988C17.8929 7.12988 16.4576 8.15002 16.4488 9.60852C16.4319 10.6846 17.4764 11.2823 18.2576 11.6411C19.0561 12.0077 19.3276 12.247 19.3276 12.5738C19.3194 13.0757 18.6823 13.3071 18.0881 13.3071C17.2641 13.3071 16.8226 13.1878 16.1516 12.9086L15.8799 12.7889L15.5911 14.4707C16.0751 14.6776 16.967 14.8613 17.8929 14.8694C20.0585 14.8694 21.4683 13.865 21.485 12.3108C21.4933 11.4579 20.9417 10.8044 19.7526 10.2704C19.0307 9.92759 18.5887 9.69644 18.5887 9.3457C18.5971 9.02684 18.9626 8.70024 19.7774 8.70024C20.4484 8.68425 20.9414 8.83563 21.3148 8.98711L21.5015 9.06667L21.7822 7.44885Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4769 7.2666H27.0733L28.7384 14.7585H26.8274C26.8274 14.7585 26.6404 13.8977 26.5811 13.6347H23.9313C23.8546 13.8338 23.4981 14.7585 23.4981 14.7585H21.3325L24.3982 7.88822C24.6106 7.40198 24.9846 7.2666 25.4769 7.2666ZM25.3497 10.0083C25.3497 10.0083 24.6956 11.6741 24.5256 12.1045H26.2411C26.1563 11.7299 25.7654 9.93653 25.7654 9.93653L25.6212 9.29098C25.5605 9.45721 25.4726 9.68577 25.4134 9.83992C25.3732 9.94441 25.3462 10.0147 25.3497 10.0083Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29398 7.2666H6.61459C7.06468 7.28239 7.4299 7.41787 7.54874 7.89638L8.27061 11.3396C8.26991 11.3379 8.26922 11.3361 8.26852 11.3343C8.26905 11.336 8.26958 11.3377 8.27011 11.3394L8.49098 12.3755L10.5122 7.26666H12.6946L9.45053 14.7508H7.26801L5.42835 8.24044C4.7938 7.89231 4.06963 7.61231 3.26001 7.41798L3.29398 7.2666Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.25H30V-0.25H2V0.25ZM31.75 2V20H32.25V2H31.75ZM30 21.75H2V22.25H30V21.75ZM0.25 20V2H-0.25V20H0.25ZM2 21.75C1.0335 21.75 0.25 20.9665 0.25 20H-0.25C-0.25 21.2426 0.757359 22.25 2 22.25V21.75ZM31.75 20C31.75 20.9665 30.9665 21.75 30 21.75V22.25C31.2426 22.25 32.25 21.2426 32.25 20H31.75ZM30 0.25C30.9665 0.25 31.75 1.0335 31.75 2H32.25C32.25 0.757359 31.2426 -0.25 30 -0.25V0.25ZM2 -0.25C0.757359 -0.25 -0.25 0.757359 -0.25 2H0.25C0.25 1.0335 1.0335 0.25 2 0.25V-0.25Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.ff9a305549964982b7b0ffd00a4926ba.svg";
export { ForwardRef as ReactComponent };